import type { PublicRenderPipelineOverrides } from './publicRenderPipelines';

export const DEFAULT_INTRO_VIEWER_MODEL_POSITION: [number, number, number] = [0, -1.25, 0];
export const DEFAULT_INTRO_VIEWER_CAMERA_TARGET_OFFSET: [number, number, number] = [3, 0.85, 2.35];
export const DEFAULT_INTRO_VIEWER_MODEL_SCALE = 0.29;

export const DEFAULT_INTRO_VIEWER_PIPELINE_OVERRIDES: PublicRenderPipelineOverrides = {
  modelPosition: DEFAULT_INTRO_VIEWER_MODEL_POSITION,
  cameraTargetOffset: DEFAULT_INTRO_VIEWER_CAMERA_TARGET_OFFSET,
  modelScale: DEFAULT_INTRO_VIEWER_MODEL_SCALE,
};
